import React, { useCallback } from 'react';
import { autoTermTableData } from 'service/service';
import CustomAnalysisTableBase from './CustomAnalysisTableBase';

const columnMapping: Record<string, string> = {
    workspace_name: 'Workspace',
    cluster_name: 'Cluster Name',
    auto_termination_minutes: 'Auto Termination (Min)',
    date: 'Date',
    owned_by: 'Owned By'
};

const defaultColumns = ['Workspace', 'Cluster Name', 'Auto Termination (Min)', 'Date', 'Owned By'];

const AutoTermPage = () => {
    const filterTableDataFn = useCallback((data: any[], mapping: Record<string, string>) => {
        return data.map((row) => {
            const filtered: Record<string, any> = {};
            Object.keys(mapping).forEach((key) => {
                if (key === "date" && row[key]) {
                    filtered[key] = new Date(row[key]).toLocaleDateString();
                } else {
                    filtered[key] = row[key];
                }
            });
            return filtered;
        });
    }, []);

    return (
        <CustomAnalysisTableBase
            fetchService={autoTermTableData}
            columnMapping={columnMapping}
            defaultColumns={defaultColumns}
            filterTableDataFn={filterTableDataFn}
            breadcrumbLabel="Auto Termination Clusters"
            tableTitle="Auto Termination Details"
            tableType="incident-details-ver"
            preserveFilterKey="auto_term_filters"
            isAutoWidth={true}
        />
    );
};

export default AutoTermPage;
